import { useState, useEffect, Fragment, useContext } from "react";
import { useNavigate } from "react-router";
import { useSignOut, useSignIn } from "react-auth-kit";
import {
  sendApiRequest,
  createQueryStringFromFilters,
} from "../../services/Base/base-service";

import Filters from "../../components/Header/Filters";
import Footer from "../../components/Footer";
import UserContext from "../../store/user-context";
import FlowsTable from "../../components/Tables/FlowsTable";
import { Alert, Section, Spinner } from "design-react-kit";

const Flows = () => {
  const [flowResults, setFlowResults] = useState(null);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const getFlows = async (data) => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      "Flow/GetFlows",
      "GET",
      true,
      data,
      signIn,
      signOut,
      navigate,
      createQueryStringFromFilters,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          setFlowResults(response.data);
          setIsLoading(false);
        }
      }
    });
  };

  const getFilters = (filters) => {
    setFilters(filters);
  };

  useEffect(() => {
    if (filters !== null) {
      setTimeout(() => {
        getFlows(filters);
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  return (
    <Fragment>
      <div>
        <Filters page="home" getFilters={getFilters} />
        <Section>
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mx-auto w-50">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          {error === null && isLoading && (
            <p style={{ height: "50px", position: "relative" }}>
              <Spinner double active />
            </p>
          )}
          {error === null &&
            !isLoading &&
            flowResults !== null &&
            flowResults.flows !== null && (
              <FlowsTable
                items={flowResults.flows}
                columns={[
                  {
                    name: "Data acquisizione",
                    type: "date",
                    sortable: true,
                    value: "importDate",
                  },
                  {
                    name: "Nome",
                    type: "string",
                    sortable: true,
                    value: "name",
                  },
                  {
                    name: "Tipologia",
                    type: "string",
                    sortable: true,
                    value: "clientServiceDescription",
                  },
                  {
                    name: "Formato",
                    type: "string",
                    sortable: false,
                    value: "format",
                  },
                  {
                    name: "Data ultima elaborazione",
                    type: "date",
                    sortable: true,
                    value: "lastProcessDate",
                  },
                  {
                    name: "Stato",
                    type: "date",
                    sortable: false,
                    value: "status",
                  },
                  {
                    name: "Azioni",
                    type: "",
                    sortable: false,
                    value: "",
                  },
                ]}
                filters={filters}
                getFlows={getFlows}
              />
            )}
        </Section>
        <Footer />
      </div>
    </Fragment>
  );
};

export default Flows;
